import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import * as Sentry from '@sentry/browser';
import { IPagination } from 'app/types/common';
import history from 'app/routes/history';
import { AdminsActionTypes as types } from './types';
/* ********************************* APP ACTIONS ********************************* */

export const createAdmin = (data): any => action(types.CREATE_ADMIN_REQUESTED, data);

export const updateAdmin = (data): any => action(types.UPDATE_ADMIN_REQUESTED, data);

export const deleteAdmin = (adminId): any => action(types.UPDATE_ADMIN_REQUESTED, adminId);

export const getAdmin = (adminId, redirectDashboard = false): any => action(types.GET_ADMIN_REQUESTED, { adminId, redirectDashboard });

export const getAllAdmins = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ADMINS_REQUESTED, { pagination, compile });

export const selectAdmin = (adminId): any => action(types.SELECT_ADMIN_REQUESTED, {
  currentAdminId: adminId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createAdminPending: (payload): any => action(types.CREATE_ADMIN_PENDING, payload),
  createAdminSuccess: (response): any => action(types.CREATE_ADMIN_SUCCESS, {
    adminsById: response.entities.admins,
    currentAdminId: response.result,
  }),
  updateAdminPending: (payload): any => action(types.UPDATE_ADMIN_PENDING, payload),
  updateAdminSuccess: (response): any => action(types.UPDATE_ADMIN_SUCCESS, {
    adminsById: response.entities.admins,
    currentAdminId: response.result,
  }),
  updateAdminFailed: (error): any => action(types.UPDATE_ADMIN_FAIL, { backendErrors: error }),
  deleteAdminPending: (): any => action(types.UPDATE_ADMIN_PENDING, {}),
  deleteAdminSuccess: (response, adminId): any => {
    localStorage.set(adminId, { currentAdminId: null });

    return action(types.DELETE_ADMIN_SUCCESS, {
      currentAdminId: response,
    });
  },
  getAdminPending: (): any => action(types.GET_ADMIN_PENDING, {}),
  getAdminSuccess: (response): any => {
    Sentry.setUser({
      username: `${response.firstName} ${response.lastName}`,
      email: response.email,
      id: response.id,
    });
    return action(types.GET_ADMIN_SUCCESS, {
      adminsById: response.entities.admins,
      currentAdminId: response.result,
    });
  },
  getAdminFailed: (error): any => {
    history.push('/login');

    return action(types.GET_ADMIN_FAIL, { backendErrors: error });
  },
  deleteAdminFailed: (error): any => action(types.DELETE_ADMIN_FAIL, { backendErrors: error }),
  getAllAdminsPending: (pagination): any => action(types.GET_ALL_ADMINS_PENDING, { pagination }),
  getAllAdminsSuccess: (response, meta): any => action(types.GET_ALL_ADMINS_SUCCESS, {
    adminsById: response.entities.admins,
    adminIds: response.result,
    meta,
  }),
  getAllAdminsFailed: (error): any => action(types.GET_ALL_ADMINS_FAIL, { backendErrors: error }),
  createAdminFailed: (error): any => action(types.CREATE_ADMIN_FAIL, { backendErrors: error }),
};

export default null;
